import { Paramaconico } from './../types/FilhoMacon'
import Irmao, { GrauMacon, SituacaoDoMacon } from './../types/Irmao'

export const listaDeGraus: GrauMacon[] = [
	'Mestre Instalado', 'Mestre', 'Companheiro', 'Aprendiz',
]

export const storageFotoIrmaoRef = process.env.NODE_ENV === 'production'
	? 'foto-irmaos'
	: 'foto-irmaos-dev'

export function ordenarIrmaosPorCargo(irmaos: Irmao[], idLoja?: string) {
	return [...irmaos]
		.sort((irmaoA, irmaoB) => {
			const [ pontuacaoA, pontuacaoB ] = [ irmaoA, irmaoB ].map(irmao => obterPontosOrdenacaoIrmao(irmao, idLoja))
			if (pontuacaoA || pontuacaoB) return pontuacaoB - pontuacaoA

			const [ cargoLojaA = '', cargoLojaB = '' ] = [ obterCargoDeAdminDaLoja(irmaoA, idLoja), obterCargoDeAdminDaLoja(irmaoB, idLoja) ]
			if (cargoLojaA && !cargoLojaB) { return -1 }
			if (!cargoLojaA && cargoLojaB) { return 1 }

			if (irmaoA.cargoDeAdminDaPotencia && !irmaoB.cargoDeAdminDaPotencia) { return -1 }
			if (!irmaoA.cargoDeAdminDaPotencia && irmaoB.cargoDeAdminDaPotencia) { return 1 }

			return cargoLojaA !== cargoLojaB
				? cargoLojaA?.localeCompare(cargoLojaB)
				: irmaoA.nomeCompleto.localeCompare(irmaoB.nomeCompleto)
		})
}

export const sortByCargoDeLoja = <T extends Irmao>(idLoja?: string) => (irmaoA: T, irmaoB: T) => {
	const [ pontuacaoA, pontuacaoB ] = [ irmaoA, irmaoB ].map(irmao => obterPontosOrdenacaoIrmao(irmao, idLoja))
	if (pontuacaoA || pontuacaoB) return pontuacaoB - pontuacaoA

	const [
		cargoLojaA = '',
		cargoLojaB = '',
	] = [
		obterCargoDeAdminDaLoja(irmaoA, idLoja)?.trim(),
		obterCargoDeAdminDaLoja(irmaoB, idLoja)?.trim(),
	]
	if (cargoLojaA && !cargoLojaB) { return -1 }
	if (!cargoLojaA && cargoLojaB) { return 1 }

	return cargoLojaA.localeCompare(cargoLojaB)
}

export function ordenarIrmaosPorCargoDeLoja(irmaos: Irmao[], idLoja?: string) {
	return [...irmaos].sort(sortByCargoDeLoja(idLoja))
}

export function obterPontosOrdenacaoIrmao(irmao: Irmao, idLoja?: string) {
	switch (obterCargoDeAdminDaLoja(irmao, idLoja)?.trim().toUpperCase()) {
		case 'VENERAVEL MESTRE':
			return 30
		case '1º VIGILANTE':
		case 'PRIMEIRO VIGILANTE':
			return 29
		case '2º VIGILANTE':
		case 'SEGUNDO VIGILANTE':
			return 28
		case 'ORADOR':
			return 27
		case 'SECRETARIO':
			return 26
		case 'CHANCELER':
			return 25
		case 'TESOUREIRO':
			return 24
		case 'MESTRE CERIMONIAS':
		case 'MESTRE DE CERIMONIAS':
			return 23
		case 'HOSPITALEIRO':
			return 22
		case 'ARQUITETO':
			return 21
		case 'MESTRE DE HARMONIA':
		case 'MESTRE HARMONIA':
			return 20
		case 'PRIMEIRO EXPERTO':
			return 19
		case 'SEGUNDO EXPERTO':
			return 18
		case 'MESTRE BANQUETE':
		case 'MESTRE DE BANQUETE':
			return 17
		case 'GUARDA INTERNO':
			return 16
		case 'GUARDA EXTERNO':
			return 15
		case 'PRIMEIRO DIACONO':
			return 14
		case 'SEGUNDO DIACONO':
			return 13
		case 'PORTA BANDEIRA':
			return 12
		case 'PORTA ESPADA':
			return 11
		case 'BIBLIOTECARIO':
			return 10
	}
	return 0
}

export type SiglaDeGrauMacon = 'A' | 'AM' | 'C' | 'CM' | 'M' | 'MM' | 'MI'

export function converterGrauMaconParaSigla(grau: GrauMacon): SiglaDeGrauMacon {
	switch (grau) {
		case 'Mestre Instalado': return 'MI'
		case 'Mestre': return 'MM'
		case 'Companheiro': return 'CM'
		case 'Aprendiz': return 'AM'
		default: throw new Error(`Grau do maçon ${grau} inválida`)
	}
}

export function converterParamaconicoDeSigla(paramaconico: 'A' | 'F' | 'FJ' | 'D' | 'E' | string): Paramaconico {
	switch (paramaconico) {
		case 'A':
		case 'ABELHINHA':
				return 'Abelhinha'
		case 'FJ':
		case 'F':
		case 'FILHA DE JO':
			return 'Filha de Jo'
		case 'D':
		case 'DEMOLAY':
			return 'Demolay'
		case 'E':
		case 'ESCUDEIRO':
			return 'Escudeiro'
		default:
			throw new Error(`Paramaçônico ${paramaconico} inválido`)
	}
}

export function converterSituacaoDoMaconDeSigla(situacao: 'R' | 'I' | 'P' | 'O' | string): SituacaoDoMacon {
	switch (situacao) {
		case 'R':
		case 'REGULAR':
			return 'Regular'
		case 'I':
		case 'IRREGULAR':
			return 'Irregular'
		case 'P':
		case 'PLACETADO':
			return 'Placetado'
		case 'O':
		case 'ETERNO':
		case 'O.ETERNO':
		case 'ORIENTE ETERNO':
			return 'Eterno'
		default:
			throw new Error(`Situação do maçon ${situacao} inválida`)
	}
}

export function converterGrauMaconDeSigla(sigla: SiglaDeGrauMacon | string): GrauMacon | undefined {
	switch (sigla) {
		case 'A':
		case 'AM':
			return 'Aprendiz'
		case 'C':
		case 'CM':
				return 'Companheiro'
		case 'M':
		case 'MM':
			return 'Mestre'
		case 'MI': return 'Mestre Instalado'
		default:
			throw new Error(`Sigla de grau do maçon ${sigla} inválido`)
	}
}
export function sortByGrauDoMacon<T extends Irmao>(irmaoA: T, irmaoB: T) {
	const [ pontuacaoA, pontuacaoB ] = [ irmaoA, irmaoB ].map(irmao => obterPontosOrdenacaoDeGrau(irmao.grauMacon))
	return pontuacaoB - pontuacaoA
}

export function obterPontosOrdenacaoDeGrau(grau: GrauMacon) {
	switch (grau) {
		case 'Mestre Instalado':
			return 12
		case 'Mestre':
			return 11
		case 'Companheiro':
			return 10
		case 'Aprendiz':
			return 9
	}
	return 0
}

export function obterTotaisPorGrau(irmaos: Irmao[]): TotaisPorGrau {
	const TOTAIS_INICIAIS: TotaisPorGrau = {
		'Mestre Instalado': 0,
		'Mestre': 0,
		'Companheiro': 0,
		'Aprendiz': 0,
	}

	const irmaosSemRepeticao = irmaos
		.reduce<Irmao[]>((irmaosNaLista, irmao) => {
			return irmaosNaLista.some(irmaoNaLista => irmao._id === irmaoNaLista._id)
				? [ ...irmaosNaLista ]
				: [ ...irmaosNaLista, irmao ]
		}, [])

	return irmaosSemRepeticao.reduce((totais, { grauMacon }) => ({
		...totais,
		[grauMacon]: totais[grauMacon] + 1,
	}), TOTAIS_INICIAIS)
}

export type TotaisPorGrau = {
	[key in GrauMacon]: number;
}

export function obterCargoDeAdminDaLoja(irmao: Pick<Irmao, 'loja' | 'situacaoDoMacon' | 'lojas' | 'cargoDeAdminDaLoja'>, idLoja?: string | null): string | undefined {
	if (!idLoja) return irmao.cargoDeAdminDaLoja;
	const idLojaString = idLoja.toString();
	if (irmao.loja?.toString() === idLojaString ||irmao.loja?._id?.toString() === idLojaString) return irmao.cargoDeAdminDaLoja;
	return irmao.lojas?.find(loja => loja.loja.toString() === idLojaString || loja.loja?._id?.toString() === idLojaString)?.cargoDeAdminDaLoja;
}
